export default [
  { text: "Dom", value: "HOUSE" },
  { text: "Garaż", value: "GARAGE" },
  { text: "Lokal użytkowy", value: "COMMERCIAL" },
  { text: "Mieszkanie", value: "FLAT" },
  { text: "Inny", value: "OTHER" },
];
